import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { Boundaries } from '@purespectrum1/ui/shared';

@Component({
  selector: 'ps-ui-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.css'],
  exportAs: 'psUiDropdown',
})
export class DropdownComponent {
  isOpen = false;
  dropup = false;

  @Input() customCssProps: object = {};
  @Input() canClose: boolean = true;
  @Input() align: 'start' | 'end' | undefined = undefined;
  @Input() toggleSubmenu: boolean = false;
  @Input() boundaries?: DOMRect;
  @Output() isClose = new EventEmitter<boolean>();

  @ViewChild('dropdown')
  public dropdown!: ElementRef<HTMLDivElement>;

  constructor() {}

  toggle() {
    this.isOpen ? this.close() : this.open();
  }

  open() {
    this._direction();
    this.isOpen = true;
    this.isClose.emit(false);
  }

  close() {
    if (this.canClose) {
      this.isOpen = false;
      this.isClose.emit(true);
    } else {
      this.isClose.emit(false);
    }

    this.dropup = false;
  }

  dropdownClass() {
    return { [`drop${this.align}`]: this.toggleSubmenu };
  }

  private _direction(): void {
    if (this.boundaries) {
      const elRect = this.dropdown.nativeElement.getBoundingClientRect();
      this.dropup = new Boundaries(
        this.boundaries,
        elRect,
        'vertical'
      ).outside();
    }
  }
}
